<template>
  <div class="shadow-1">
    <q-tabs v-model="tab" dense>
      <q-btn
        v-if="farmBackBtn"
        padding="2px 10px"
        icon="arrow_back"
        color="blue-14"
        class="q-mx-md"
        @click="goBackToFarm"
      />
      <q-btn
        v-if="emailBackBtn"
        padding="2px 10px"
        icon="arrow_back"
        color="blue-14"
        class="q-mx-md"
        @click="goBackToEmail"
      />
      <q-btn
        v-if="workOrderBackBtn"
        padding="2px 10px"
        icon="arrow_back"
        color="blue-14"
        class="q-mx-md"
        @click="goBackToWorkOrders"
      />
      <div
        class="text-subtitle1 q-py-sm"
        :class="
          !farmBackBtn && !emailBackBtn && !workOrderBackBtn ? 'q-pl-md' : ''
        "
      >
        {{ decoder(farmName) }}
      </div>
      <q-space />

      <!-- Desktop tabs -->
      <template v-if="$q.screen.gt.md">
        <q-route-tab
          name="map"
          :to="'/farm/' + farmId"
          label="Map"
          style="max-width: 135px"
        />
        <q-route-tab
          name="workLogs"
          :to="'/farm/' + farmId + '/work'"
          label="Work Logs"
          style="max-width: 135px"
        />
        <q-route-tab
          name="bulletins"
          :to="'/farm/' + farmId + '/bulletins'"
          label="Bulletins"
          style="max-width: 135px"
        />
        <q-route-tab
          name="emails"
          :to="'/farm/' + farmId + '/emails'"
          label="Emails"
          style="max-width: 135px"
        />
        <q-route-tab
          name="todos"
          :to="'/farm/' + farmId + '/todos'"
          label="To-Do"
          style="max-width: 135px"
        />
        <q-route-tab
          name="ponds"
          :to="'/farm/' + farmId + '/ponds'"
          label="Ponds"
          style="max-width: 135px"
        />
        <q-route-tab
          name="computers"
          :to="'/farm/' + farmId + '/computers'"
          label="Computers"
          style="max-width: 135px"
        />
        <q-route-tab
          name="repeaters"
          :to="'/farm/' + farmId + '/repeaters'"
          label="Repeaters"
          style="max-width: 135px"
        />
        <q-route-tab
          name="attachments"
          :to="'/farm/' + farmId + '/attachments'"
          label="Attachments"
          style="max-width: 135px"
        />
      </template>

      <!-- Mobile icon buttons -->
      <template v-if="$q.screen.lt.lg">
        <!-- Work Logs button -->
        <q-btn
          unelevated
          color="grey-3"
          :text-color="tab === 'work' ? 'primary' : 'grey'"
          icon="assignment"
          class="q-mr-sm"
          padding="2px 10px"
          @click="goToTab('work')"
        />

        <!-- Map button -->
        <q-btn
          unelevated
          color="grey-3"
          :text-color="tab === '' ? 'primary' : 'grey'"
          icon="map"
          class="q-mr-sm"
          padding="2px 10px"
          @click="goToTab('')"
        />

        <!-- More dropdown -->
        <q-btn-dropdown
          unelevated
          color="grey-3"
          text-color="black"
          label="Pages"
          auto-close
          padding="2px 10px"
          class="q-mr-sm"
          :menu-offset="[0, 8]"
        >
          <q-list>
            <q-item-label header>Navigation</q-item-label>

            <q-separator />

            <q-item v-ripple clickable @click="goToTab('bulletins')">
              <q-item-section avatar>
                <q-icon
                  :color="tab === 'bulletins' ? 'primary' : 'grey'"
                  name="dashboard"
                />
              </q-item-section>
              <q-item-section>Bulletins</q-item-section>
            </q-item>

            <q-item v-ripple clickable @click="goToTab('emails')">
              <q-item-section avatar>
                <q-icon
                  :color="tab === 'emails' ? 'primary' : 'grey'"
                  name="email"
                />
              </q-item-section>
              <q-item-section>Emails</q-item-section>
            </q-item>

            <q-item v-ripple clickable @click="goToTab('todos')">
              <q-item-section avatar>
                <q-icon
                  :color="tab === 'todos' ? 'primary' : 'grey'"
                  name="check_box"
                />
              </q-item-section>
              <q-item-section>To-Do</q-item-section>
            </q-item>

            <q-item v-ripple clickable @click="goToTab('ponds')">
              <q-item-section avatar>
                <q-icon
                  :color="tab === 'ponds' ? 'primary' : 'grey'"
                  name="water"
                />
              </q-item-section>
              <q-item-section>Ponds</q-item-section>
            </q-item>

            <q-item v-ripple clickable @click="goToTab('computers')">
              <q-item-section avatar>
                <q-icon
                  :color="tab === 'computers' ? 'primary' : 'grey'"
                  name="computer"
                />
              </q-item-section>
              <q-item-section>Computers</q-item-section>
            </q-item>

            <q-item v-ripple clickable @click="goToTab('repeaters')">
              <q-item-section avatar>
                <q-icon
                  :color="tab === 'repeaters' ? 'primary' : 'grey'"
                  name="router"
                />
              </q-item-section>
              <q-item-section>Repeaters</q-item-section>
            </q-item>

            <q-item v-ripple clickable @click="goToTab('attachments')">
              <q-item-section avatar>
                <q-icon
                  :color="tab === 'attachments' ? 'primary' : 'grey'"
                  name="attach_file"
                />
              </q-item-section>
              <q-item-section>Attachments</q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-tabs>
  </div>
</template>

<script>
import { decoder } from '@/lib/helpers';

export default {
  name: 'farm-tabs',
  props: {
    farmId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      emailBackBtn: false,
      farmBackBtn: false,
      workOrderBackBtn: false,
      tab: 'work'
    };
  },
  mounted() {
    this.checkEmailBackBtn();
    this.checkFarmBackBtn();
    this.checkWorkOrderBackBtn();
  },
  methods: {
    checkEmailBackBtn() {
      const scrollObj = this.$store.state.emailScrollTo;
      if (scrollObj.goStatus === 'active') {
        this.emailBackBtn = true;
      }
      scrollObj.goStatus = 'inactive';
      this.$store.dispatch('setEmailScrollTo', scrollObj);
    },
    checkFarmBackBtn() {
      const scrollObj = this.$store.state.farmScrollTo;
      if (scrollObj.goStatus === 'active') {
        this.farmBackBtn = true;
      }
      scrollObj.goStatus = 'inactive';
      this.$store.dispatch('setFarmScrollTo', scrollObj);
    },
    checkWorkOrderBackBtn() {
      const scrollObj = this.$store.state.workOrderScrollTo;
      if (scrollObj.goStatus === 'active') {
        this.workOrderBackBtn = true;
      }
      scrollObj.goStatus = 'inactive';
      this.$store.dispatch('setWorkOrderScrollTo', scrollObj);
    },
    goBackToEmail() {
      const scrollObj = this.$store.state.emailScrollTo;
      scrollObj.goStatus = 'go';
      this.$store.dispatch('setEmailScrollTo', scrollObj);
      this.$router.push('/emails');
    },
    goBackToFarm() {
      const scrollObj = this.$store.state.farmScrollTo;
      scrollObj.goStatus = 'go';
      this.$store.dispatch('setFarmScrollTo', scrollObj);
      this.$router.push('/');
    },
    goBackToWorkOrders() {
      const scrollObj = this.$store.state.workOrderScrollTo;
      scrollObj.goStatus = 'go';
      this.$store.dispatch('setWorkOrderScrollTo', scrollObj);
      this.$router.push('/work-orders/');
    },
    goToTab(tab) {
      this.$router.push(`/farm/${this.farmId}/${tab}`);

      this.tab = tab;
    },
    decoder(val) {
      return decoder(val);
    }
  },
  computed: {
    farmName() {
      const farm = this.$store.state.farmList.find(
        (e) => e.id === parseInt(this.farmId)
      );
      return farm ? farm.farm_name : '';
    }
  }
};
</script>
